import React, { useEffect, useState } from 'react';
import './footer.scss';
import { NavLink } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import AppImage from '../features/image';
import AppCTA from '../features/cta';
import { footerLinks, techBlack } from '../utils/constant';
import { SectionWrapper } from '../../theme/layouts/MainLayout';

export function LinkList() {
  return (
    <div className='py-2'>
      <ul>
        {footerLinks.map((item) => (
          <li key={item.title}>
            <NavLink to={item.url} target='_blank' className="foot-links">
              {item.title}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  )
}
function Footer(props) {
  const { data } = props;
  const [isMobile, setIsMobile] = useState(false);

  const footerBannerUrl = data?.footerBanner || '/images/footer/footer_see-whats-possible.png';
  const footerBannerUrlMobile = data?.footerBannerMobile || '/images/footer/footer_see-whats-possible_mobile.png';
  const title = data?.footerTitle || 'See what’s possible.';
  const ctaText = data?.ctaText || 'Let’s get started';
  const ctaUrl = data?.ctaUrl || '/lets-talk';
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };
 
    window.addEventListener('resize', handleResize);
    handleResize();
 
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <SectionWrapper bg={techBlack}>
      <footer>
      <div className='footer-section'>
        <Row>
          <Col md={6} xs={12} sm={12} className='d-flex flex-column'>
            <AppImage src={isMobile ? footerBannerUrlMobile : footerBannerUrl} alt="img" className="w-100 foot-banner-img" />
          </Col>
          <Col md={6} xs={12} sm={12}>
            <div className="d-flex flex-column justify-content-between footer-content">
              <div className='header-text'>
                <h1>{title}</h1>
              </div>

              <div className='cta-footer-text'>
                <AppCTA title={ctaText} url={ctaUrl} />
              </div>

              <div className='footer-navlinks'>
                <div className='py-2'>
                  <ul>
                    {footerLinks.map((item) => (
                      <li key={item.title}>
                        <NavLink to={item.url} target={item.target?'_blank':'_self'} className="foot-links">
                          {item.title}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="copyright">
                  <div className="content">
                    ©{new Date().getFullYear()} Best Buy. All rights reserved.
                  </div>
                  <div>
                    <NavLink to="https://www.linkedin.com/company/best-buy-ads" target="_blank" className="d-flex justify-content-end w-100 social-img" >
                      <AppImage src={'/images/footer/footer_linked-in_icon.svg'} alt="Linkedin Img" />
                    </NavLink>
                  </div>
                </div>

              </div>
            </div>
          </Col>
        </Row>
      </div>
    </footer>
      </SectionWrapper>
  )
}

export default React.memo(Footer);